<template>
  <input
    class="config-dynamic-input"
    :value="value"
    :style="inputStyle"
    type="text"
    placeholder="content..."
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'ConfigTextElement',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    defaultStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    inputStyle () {
      return {
        borderColor: this.defaultStyle.borderColor,
        backgroundColor: this.defaultStyle.backGroundColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.config-dynamic-input {
  width: 100%;
  height: 30px;
  border: 1px solid #dfe5ed;
  border-radius: 4px;
  background: #ffffff;
  padding: 0 10px;
  font-size: var(--text-xs2);
  outline: none;

  &:focus {
    border-color: var(--brand-color);
  }
}
</style>
